import React from 'react';

const Loading = () => (
  <div className="flex flex-col items-center justify-center min-h-[30vh]">
    <div className="w-10 h-10 border-4 border-gray-200 border-t-black rounded-full animate-spin mb-4"></div>
    <div className="text-black text-lg font-medium">Loading, please wait…</div>
  </div>
);

export default Loading;